import { RobLocationBM } from '../../types/BusinessModel/TankCleaning/RobLoctionBM';
import { RobLocation } from '../../types/ViewModel/TankCleaning/ROB/RobLoction';

export const createRobLocationBMItem = (robLocation: RobLocation): RobLocationBM => {
    return {
        chemicalRobItemLocationId: 0,
        robLocationDropdownItemId: robLocation.robLocationDropdownItemId,
        robValue: robLocation.robValue,
        locationIndex: robLocation.locationIndex,
    };
};

export const createRobLocationBMItemList = (robLocations: RobLocation[]) => robLocations.map((robLocation) => createRobLocationBMItem(robLocation));

export const createRobLocationItem = (robLocationBM: RobLocationBM): RobLocation => {
    return {
        robLocationDropdownItemId: robLocationBM.robLocationDropdownItemId,
        robValue: robLocationBM.robValue,
        locationIndex: robLocationBM.locationIndex,
    };
};

export const createRobLocationItemList = (robLocationBMs: RobLocationBM[]) =>
    robLocationBMs.map((robLocationBM) => createRobLocationItem(robLocationBM));
